import BaseApi from "./_base-api";

/**
 * FAQ API
 *
 * @class Api
 * @extends {BaseApi}
 */
class Api extends BaseApi {
	getOne(params) {
		const id = params instanceof Object ? params.id : params;
		if(params instanceof Object && params.id) {
			delete params.id;
		}
		return this.api()
			.get(this.getUrl("faq") + '/' + id, { params })
			.catch(error => {
				this.log().error("[Services Error: FAQ: Getting faq]:", error);
				throw this.utils.resolveError(error);
			});
	}
}

const api = new Api({
	type: "FAQ",
	path: "faqs"
});

export default api;
